import { Grid } from "@mui/material";
import { useContext, useState } from "react";
import { GlobalAlertContext } from "../../../contexts/GlobalAlertContext";
import { api } from "../../../services/api";
import SubTitleCard from "../../signin/cardLogin/subTitleCard";
import TitleCard from "../../signin/cardLogin/titleCard";
import ButtonSubmit from "../buttonSubmit";
import InputEmail from "../inputEmail";
import ButtonBack from "../../signin/buttonBack";

export default function ForgotPassword({ handleBack, handleNext }) {
  const [email, setEmail] = useState({
    error: false,
    value: "",
    errorText: "Error",
  });
  const { handleToast, handleLoading } = useContext(GlobalAlertContext);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (email.value === "") {
      handleToast(true, "error", "Por favor insira um email");
      return;
    }

    handleLoading(true);

    try {
      const { data } = await api({
        method: "POST",
        url: "/user/recoverCode",
        data: { email: email.value },
      });
      handleToast(true, data.toast, data.message);
      handleNext(email.value, handleSubmit);
    } catch (err) {
      handleToast(true, err.response.data.toast, err.response.data.message);
    }
    handleLoading(false);
  };

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
      >
        <Grid item xs={12}>
          <ButtonBack onClick={() => handleBack()}></ButtonBack>
        </Grid>
        <Grid item xs={12} sx={{ marginTop: "56px" }}>
          <TitleCard
            sx={{
              fontWeight: "bold",
              color: "black",
              fontSize: "1.5rem",
            }}
          >
            Redefinir Senha
          </TitleCard>
        </Grid>
        <Grid item xs={12} sx={{ marginTop: "32px" }}>
          <SubTitleCard> 
            Insira seu e-mail para receber o código de verificação
          </SubTitleCard>
        </Grid>

        <Grid item xs={12} sm={12} sx={{ marginTop: "32px",}}>
          <InputEmail 
            {...email}
            sx={{fontSize:"1.5rem"}}
            required
            onChange={({ target }) =>
              setEmail((obj) => {
                obj.value = target.value;
                obj.error = false;
                return { ...obj };
              })
            }
          />
        </Grid>
        <Grid item xs={"auto"} sx={{ marginTop: "64px" }}>
          <ButtonSubmit onClick={handleSubmit}>Receber código</ButtonSubmit>
        </Grid>
      </Grid>
    </>
  );
}
